// extracted by mini-css-extract-plugin
module.exports = {"cancelButton":"UpdateRegion_cancelButton__t5g3Y"};